// extracted by mini-css-extract-plugin
module.exports = {"medium":"1024px","wrapper":"Carousel_wrapper__wmIq6"};